export const LOAD_USER_ACCESS= "LOAD_USER_ACCESS";
export const LOAD_USER_ACCESS_SUCCESS = "LOAD_USER_ACCESS_SUCCESS";
export const LOAD_USER_ACCESS_ERROR = "LOAD_USER_ACCESS_ERROR";


